import{forwardRef as p}from"react";const r=p,t=p;export{r as typeScriptHappyForwardRef,t as typescriptHappyForwardRef};